export default "__VITE_ASSET__9bIACGDk__"